const constants = {
  USER2_CONTEXT_STORE_MODULE_NAME: 'featureUser2',
}
export default constants
